import React, { useEffect } from "react";
import { Progress } from "antd";
import GradientButton from "./Button/GradientButton";
import { useDispatch, useSelector } from "react-redux";
import { getCourseProgressDetails } from "../slices/courseraSlice";
import LoadingCom from "./LoadingCom";

const CourseCard = ({ course }) => {
  return (
    <div className="border rounded-md p-4 mb-4 flex items-center justify-between">
      <div className="flex-1">
        <h2 className="text-lg font-semibold">{course.contentName}</h2>
        <p className="text-gray-600">{course.partnerNames.join(", ")}</p>
        <p className="text-gray-500">Program: {course.programName}</p>
        <p className="text-gray-500">
          Enrolled At: {new Date(course.enrolledAt).toLocaleDateString()}
        </p>
        <Progress
          percent={!course.isCompleted ? course?.overallProgress : 100}
          //   status="active"
        />
        {course.isCompleted && <p className="text-green-500">Completed</p>}
        {!course.isCompleted && <p className="text-red-500">Not Completed</p>}
      </div>
      <div>
        <GradientButton>
          <a
            href={
              !course.isCompleted
                ? `https://www.coursera.org/learn/${course.contentSlug}`
                : course.contentCertificateUrl
            }
            target="blank"
          >
            {!course.isCompleted ? "Resume" : "View Certificate"}
          </a>
        </GradientButton>
      </div>
    </div>
  );
};

const CourseProgress = () => {
  const dispatch = useDispatch();
  const email = localStorage.getItem("username");
  const courseProgressData = useSelector(
    (state) => state.coursera.courseProgressData
  );
  const courseProgressCurrentUserData = courseProgressData?.filter(
    (data) => data.email === email
  );
  console.log(
    "🚀 ~ CourseCard ~ courseProgressData:",
    courseProgressCurrentUserData
  );

  useEffect(() => {
    dispatch(getCourseProgressDetails());
  }, []);
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-semibold mb-4">Courses</h1>
      {courseProgressCurrentUserData?.length ? (
        courseProgressCurrentUserData?.map((course) => (
          <CourseCard key={course.id} course={course} />
        ))
      ) : (
        <div className="text-center">
          <h1 className="bg-signupTextBg inline-block text-transparent bg-clip-text font-semibold">
            You Are Not Enrolled in Any Course
          </h1>
        </div>
      )}
    </div>
  );
};

export default CourseProgress;
